import {polygon} from '@turf/turf';

export const generatePolygonToAllMap = () => {
  return polygon([
    [
      [180, 90],
      [180, -90],
      [-180, -90],
      [-180, 90],
      [180, 90],
    ],
  ]);
};
